import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type BUDGET_TYPE} from './constants';

const domain = 'ABSTRACT_BUDGET';

export const {
    action: fetchBudget,
    success: fetchBudgetSuccess,
    failed: fetchBudgetFailed,
} = createAction(
    `${domain}/FETCH_BUDGET`,
    (institutionId: string, year: string, type: BUDGET_TYPE) => ({institutionId, year, type}),
    (response, type: BUDGET_TYPE) => ({response, type}),
);

export const {
    action: updateBudget,
    success: updateBudgetSuccess,
    failed: updateBudgetFailed,
} = createAction(
    `${domain}/UPDATE_BUDGET`,
    (institutionId, values, year: string, type: BUDGET_TYPE) => ({institutionId, values, year, type}),
    (response, year, institutionId, type: BUDGET_TYPE) => ({response, year, institutionId, type}),
);
